// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Canvas | Notebook switch in the canvas bar: one bordered group of two
   options, the one showing filled, as tall as the bar's other controls. */

.aLJxaI3rrzwcIwxKCXy4 {
  display: inline-flex;
  align-items: stretch;
  height: 28px;
  margin: 0 2px;
  border: 1px solid var(--curio-top-bar-control-border);
  border-radius: var(--curio-radius-md);
  overflow: hidden;
  flex-shrink: 0;
}

.doBRqq4aijt2Afjf_GLs {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding: 0 7px;
  background: transparent;
  border: none;
  color: var(--curio-text-on-dark-muted);
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.doBRqq4aijt2Afjf_GLs + .doBRqq4aijt2Afjf_GLs {
  border-left: 1px solid var(--curio-top-bar-control-border);
}

.doBRqq4aijt2Afjf_GLs:hover,
.F22Mq_zVJBfXzTG50ZtW {
  background-color: var(--curio-top-bar-bg-hover);
  color: var(--curio-text-on-dark);
}

.doBRqq4aijt2Afjf_GLs:focus-visible {
  outline: 2px solid var(--curio-focus-ring);
  outline-offset: -2px;
}

.dUvPlO1ZnN2mJ9u0THMp {
  font-size: 12px;
}

/* The words take about 110px more than the icons, so they go first when the
   bar's slot runs short, before the catalogs' labels do (UpMenu.module.css).
   The slot's controls need about 900px with them. */
@container (max-width: 910px) {
  .KscLUN1aKm5aJJvkr2VR {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/top/CanvasViewSwitch.module.css"],"names":[],"mappings":"AAAA;0EAC0E;;AAE1E;EACE,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;;EAEE,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;;oDAEoD;AACpD;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* The Canvas | Notebook switch in the canvas bar: one bordered group of two\n   options, the one showing filled, as tall as the bar's other controls. */\n\n.switch {\n  display: inline-flex;\n  align-items: stretch;\n  height: 28px;\n  margin: 0 2px;\n  border: 1px solid var(--curio-top-bar-control-border);\n  border-radius: var(--curio-radius-md);\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.option {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin: 0;\n  padding: 0 7px;\n  background: transparent;\n  border: none;\n  color: var(--curio-text-on-dark-muted);\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.option + .option {\n  border-left: 1px solid var(--curio-top-bar-control-border);\n}\n\n.option:hover,\n.optionChecked {\n  background-color: var(--curio-top-bar-bg-hover);\n  color: var(--curio-text-on-dark);\n}\n\n.option:focus-visible {\n  outline: 2px solid var(--curio-focus-ring);\n  outline-offset: -2px;\n}\n\n.icon {\n  font-size: 12px;\n}\n\n/* The words take about 110px more than the icons, so they go first when the\n   bar's slot runs short, before the catalogs' labels do (UpMenu.module.css).\n   The slot's controls need about 900px with them. */\n@container (max-width: 910px) {\n  .label {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `aLJxaI3rrzwcIwxKCXy4`,
	"option": `doBRqq4aijt2Afjf_GLs`,
	"optionChecked": `F22Mq_zVJBfXzTG50ZtW`,
	"icon": `dUvPlO1ZnN2mJ9u0THMp`,
	"label": `KscLUN1aKm5aJJvkr2VR`
};
export default ___CSS_LOADER_EXPORT___;
